<div class="wrapper page-heading primary-bg" [ngClass]="{'no-margin-b': disableMarginBottom}">
    <div class="page-heading-left">
        <ng-content select=".page-heading-left-content"></ng-content>

        <h1 [i18n]="key ? [{target: 'innerHTML', key: key, params: i18nParams}] : []">{{title}}</h1>

        <ng-select *ngIf="regions.length > 0"
                   [items]="regions"
                   [bindLabel]="'name'"
                   [addTag]="true"
                   [placeholder]="'-- Select a Region --'"
                   [hideSelected]="false"
                   [multiple]="false"
                   [(ngModel)]="selectedRegion"
                   (change)="regionChanged()"
                   (clear)="regionCleared()"
                   [clearable]="clearable"
                   [notFoundText]="'Region not found'">
        </ng-select>

        <ng-select *ngIf="carriers.length > 0 || forceShowCarrier"
                   [items]="carriers"
                   [bindLabel]="'name'"
                   [addTag]="true"
                   [placeholder]="carrierSelectPlaceholderText"
                   [hideSelected]="false"
                   [multiple]="false"
                   [(ngModel)]="selectedCarrier"
                   (change)="carrierChanged()"
                   (clear)="carrierCleared()"
                    [notFoundText]="'Carrier not found'"
                   [clearable]="clearable">
        </ng-select>

        <div class="page-heading-left header-info" *ngIf="info">
            <i class="fa fa-info-circle"></i>
            <span [i18n]="infoMessageKey"></span>
        </div>
    </div>


    <div class="page-heading-right">
        <ng-content select=".page-heading-right-content"></ng-content>

         <span class="helper" *ngIf="needVendorNumber">
            <span>?</span>
            <span class="tooltip" [i18n]="'user-dashboard.carriers.need-vendor-number'" style="display: none"></span>
        </span>

        <div *ngIf="subheadingIcon || subheadingLabelKey || subInfoLabelKey" class="page-subheading">
            <div class="page-subheading-container">
                <p *ngIf="subheadingIcon || subheadingLabelKey">
                    <i class="{{subheadingIcon}}" *ngIf="subheadingIcon"></i> <strong *ngIf="subheadingLabelKey " [i18n]="subheadingLabelKey"></strong>
                </p>

                <ng-select *ngIf="timeZone"
                           [items]="timeZonesOptions"
                           [bindLabel]="'label'"
                           [hideSelected]="false"
                           [multiple]="false"
                           [(ngModel)]="selectedTimeZone"
                           (change)="timeZoneChanged()"
                           [clearable]="false"   >
                </ng-select>
            </div>
            <div *ngIf="subInfoLabelKey" class="page-subheading-tooltip">
                <i class="fa fa-info-circle space-right-5"></i>
                <span [i18n]="subInfoLabelKey"></span>
            </div>
        </div>

        <div class="main-helper" *ngIf="helper">
            <span class="helper-icon" (click)="toggleHelper()">?</span>
            <div class="helper-content" *ngIf="helperActive">
                <div [ngTemplateOutlet]="helperContent"></div>
            </div>
        </div>
    </div>
</div>
